import { Record } from "immutable";

import { DirectoryGroupModel } from "./DirectoryGroupModel";

const defaults = {
  directoryGroup: null as DirectoryGroupModel | null,
  directoryGroupId: "",
  id: "",
  maintainerGroupId: "",
};

export class DirectoryGroupMaintainerModel extends Record<typeof defaults>(defaults) implements IMaintainerModel {
  get entity(): DirectoryGroupModel | null {
    return this.directoryGroup;
  }

  get entityId(): string {
    return this.directoryGroupId;
  }

  static fromEntity(entity: DirectoryGroupModel): DirectoryGroupMaintainerModel {
    return new DirectoryGroupMaintainerModel({
      directoryGroup: entity,
      directoryGroupId: entity.id,
      id: "",
      maintainerGroupId: "",
    });
  }

  static fromServerData(data: unknown): DirectoryGroupMaintainerModel {
    const { directoryGroup, directoryGroupId, id, maintainerGroupId } = data as typeof defaults;
    return new DirectoryGroupMaintainerModel({
      directoryGroup: directoryGroup ? DirectoryGroupModel.fromServerData(directoryGroup) : null,
      directoryGroupId,
      id,
      maintainerGroupId,
    });
  }
}
